/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Rights} from "./rights";

export const getCRMRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_CRM
  ];
};

export const getSAFTRights = () => {
  return [
    Rights.ROLE_SAFT,
    Rights.ROLE_ADMIN
  ]
}

export const getDeliveryRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_FINANCIAL,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_SP_DISPATCHER,
    Rights.ROLE_SP_AUTO_PARK,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_CUSTOMER_FINANCIAL,
    Rights.ROLE_INTERNAL
  ]
};

export const getEmailAuthRights = () => {
  return [
    Rights.ROLE_EMAIL_AUTH
  ]
};

export const getCompanyShellRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_DETALII_COMPANIE,
    Rights.ROLE_PROFIL_COMPANIE
  ];
};

export const getAllCompanyListRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_DETALII_COMPANIE
  ];
};

export const getSelectItemsRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_SELECT_ITEMS_ADMIN];
};
